import(/* webpackMode: "eager" */ "/home/ubuntu/download/69883ec5921dc900142f22f1/website_project/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69883ec5921dc900142f22f1/website_project/src/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69883ec5921dc900142f22f1/website_project/src/styles/index.css");
